import React from "react";
import * as Icon from "ubs-icons";
import {COLOR} from "../constant";
import PropTypes from "prop-types";
import UPopup from "../UPopup";
import UScrollbar from "../UScrollbar";
import TSkeleton from "../skeleton/table-skeleton";
import NoDataFound from "../no-data-found";
import UPagination from "../UPagination";

const UTableHeader = React.memo((props) => {
    return <React.Fragment>
        {props?.visible &&
        <th>
            <div className="u_ib u_cp">
                <div className="u_flex"
                     onClick={() => props?.sort && !props?.dataLoading && props.onSort({[props?.param]: props.sortType === 1 ? -1 : 1})}>
                    {props?.title}
                    {props?.sort && <div className="u_sort u_pl-10">
                <span className="u_sort-top">
                    <Icon.SortRightArrow size={10} fill={props.sortType === 1 ? COLOR.u_icon_bg : COLOR.u_gray}/>
                </span>
                        <span className="u_sort-down">
                    <Icon.SortRightArrow size={10} fill={props.sortType === -1 ? COLOR.u_icon_bg : COLOR.u_gray}/>
                </span>
                    </div>}
                </div>
            </div>
        </th>
        }
    </React.Fragment>
})

UTableHeader.propTypes = {
    visible: PropTypes.bool,
    title: PropTypes.string,
    width: PropTypes.number,
    param: PropTypes.string,
    sort: PropTypes.bool,
    sortType: PropTypes.number,
    onSort: PropTypes.func,
    dataLoading: PropTypes.bool,
}

UTableHeader.defaultProps = {
    visible: true,
    title: '',
    width: 100,
    param: '',
    sort: false,
    sortType: 0,
    onSort: () => {
    },
    dataLoading: true
};

const UTableBody = React.memo((props) => {
    return <React.Fragment>
        {props?.visible && <td className={`${props?.dataClassName}`}>
            {props.tooltip ? <div className="u_table-long-text"><UPopup
                params={{className: "u_tooltip"}}
                desc={<span>{props.render}</span>}
            >
                <span className="u_one-line">{props.render}</span>
            </UPopup></div> : props.render}

        </td>}
    </React.Fragment>
})

UTableBody.propTypes = {
    visible: PropTypes.bool,
    param: PropTypes.string,
    render: PropTypes.any,
    tooltip: PropTypes.bool,
    dataClassName: PropTypes.string
}

UTableBody.defaultProps = {
    visible: true,
    param: 'param',
    render: '-',
    tooltip: false,
    dataClassName: ''
};

const UTable = React.memo((props) => {
    return (<React.Fragment>
            <div className="u_layout-scrollview">
                <UScrollbar>
                    <div className={`u_table-resource ${props?.className}`}>
                        <table>
                            <thead>
                            <tr>
                                {props?.header?.map(data => <UTableHeader
                                    visible={data?.visible}
                                    title={data?.title}
                                    width={data?.width}
                                    sort={data?.sort}
                                    param={data?.param}
                                    dataLoading={props?.dataLoading}
                                    sortType={props?.sort[data?.param]}
                                    onSort={(e) => props?.onSort(e)}
                                />)}
                            </tr>
                            </thead>
                            <tbody>
                            {props?.dataLoading ? <TSkeleton col={props?.skeletonColumn}/> :
                                <React.Fragment>
                                    {props?.data?.length !== 0 && props?.data?.map((data, i) => <tr key={i} className={typeof props?.rowClassName === 'function' ? props?.rowClassName(data, i) : props?.rowClassName}>
                                            {props.header.map(header => {
                                                return <UTableBody
                                                    visible={header.visible}
                                                    param={header.param}
                                                    render={header?.render ? header?.render(data) : data[header.param]}
                                                    tooltip={header?.tooltip}
                                                    className={header?.className}
                                                    dataClassName={header?.dataClassName}
                                                />
                                            })}
                                        </tr>
                                    )}
                                </React.Fragment>}
                            </tbody>
                        </table>
                    </div>
                    {props?.data?.length === 0 && <NoDataFound/>}
                </UScrollbar>
            </div>

            <div className={props?.footer ? 'u_table-footer' : ''}>
                {props?.footer && props?.footer}
                <UPagination onChange={props.onPagination} totalRecords={props.totalRecords}
                             currentPage={props?.currentPage} limit={props?.limit}/>
            </div>
        </React.Fragment>
    );
});

UTable.propTypes = {
    header: PropTypes.array,
    data: PropTypes.array,
    sort: PropTypes.object,
    onSort: PropTypes.func,
    onPagination: PropTypes.func,
    totalRecords: PropTypes.number,
    currentPage: PropTypes.number,
    limit: PropTypes.number,
    dataLoading: PropTypes.bool,
    skeletonColumn: PropTypes.number,
    footer: PropTypes.any,
    className: PropTypes.string,
    dataClassName: PropTypes.string,
    rowClassName: PropTypes.any,
}

UTable.defaultProps = {
    header: [],
    data: [],
    sort: {},
    onSort: () => {
    },
    onPagination: () => {
    },
    totalRecords: 0,
    currentPage: 0,
    limit: 0,
    dataLoading: true,
    skeletonColumn: 1,
    footer: false,
    className: '',
    dataClassName: '',
    rowClassName: '',
};

export default UTable